import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { observable, action, makeObservable } from "mobx";
import * as React from "react";

/**
 * The interface for receiving callbacks from a dialog.
 */

/**
 * The interface for React context related to dialogs.
 */

export const DialogContext = /*#__PURE__*/React.createContext(undefined);
DialogContext.displayName = "DialogContext";
export let DialogActionState = (_class = class DialogActionState {
  constructor() {
    /** Is the dialog waiting for a promise to resolve? */
    _initializerDefineProperty(this, "waitingForPromise", _descriptor, this);
    makeObservable(this);
    this.waitingForPromise = undefined;
  }
  setWaitingForPromise(value) {
    this.waitingForPromise = value;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "waitingForPromise", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setWaitingForPromise", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setWaitingForPromise"), _class.prototype), _class);
//# sourceMappingURL=DialogContext.js.map
